import { getAuthCode } from '@/api/api'
// 获取地址栏参数，name:参数名称
export function getUrlParms(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}

export function handleGoToPath (url) {
  if (!url) return
  let https = `${process.env.viewURL}`
  getAuthCode().then(res => {
    if (url.indexOf('?') > -1) {
      url += `&code=${res.data.code}`
    } else {
      url += `?code=${res.data.code}`
    }
    console.log(`${https}${url}`)
    window.location.href = `${https}${url}`
  })
}

export default {
  getUrlParms,
  handleGoToPath
}



// WEBPACK FOOTER //
// ./src/utils/comm.js